import ManagerCustomerAccount from './ManagerCustomerAccount';

export default ManagerCustomerAccount;
